import { Link, useLocation } from "react-router-dom";

const HOME_PATHS = ["/", "/about"];

/**
 * Link to a homepage section such as "#faq". On the homepage it stays a plain
 * anchor so the browser scrolls natively; elsewhere it routes to "/#faq" and
 * HomePage scrolls the section into view once it renders.
 */
export function SectionLink({ hash, children, ...props }) {
  const { pathname } = useLocation();
  if (HOME_PATHS.includes(pathname)) {
    return (
      <a href={hash} {...props}>
        {children}
      </a>
    );
  }
  return (
    <Link to={`/${hash}`} {...props}>
      {children}
    </Link>
  );
}
